import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface DraftActionsProps {
  onSubmit: () => void
  saving?: boolean
  saveError?: boolean
  submitting?: boolean
  /** Secondary control placed before the submit button, e.g. the wizard's "Kembali". */
  leading?: ReactNode
}

export function DraftActions({ onSubmit, saving, saveError, submitting, leading }: DraftActionsProps) {
  const { t } = useTranslation()

  return (
    <div className="prod-draft-bar">
      {leading}
      <button
        type="button"
        className="prod-btn prod-btn--gold"
        onClick={onSubmit}
        disabled={submitting || saving}
      >
        {submitting ? t('common.saving') : t('form.submitForApproval')}
      </button>
      {saving ? (
        <span className="prod-draft-bar__status" aria-live="polite">
          {t('common.saving')}
        </span>
      ) : saveError ? (
        <span className="prod-draft-bar__status prod-draft-bar__status--error" aria-live="polite">
          {t('common.saveFailed')}
        </span>
      ) : null}
    </div>
  )
}
